/* eslint-disable react-hooks/exhaustive-deps */
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { customerHandler, masterHandler } from '../../../redux/handlers';
import { BusinessModal } from '../modals/BusinessModal';
import { ChangePackageModal } from '../modals/ChangePackageModal';

export function BusinessDetails() {
  const dispatch = useDispatch();
  const { businessID } = useParams();

  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const { prefixNames } = useSelector(state => state.master);

  const [modalBusiness, setModalBusiness] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 1360,
    height: 860,
    pin: false,
    mode: 'normal',
    modalname: 'create'
  });

  const [modalPackage, setModalPackage] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 860,
    height: 760,
    pin: false,
    mode: 'normal',
    modalname: 'package'
  });

  const fetchBusinessData = async () => {
    if (businessID) {
      try {
        const businessData = await dispatch(customerHandler.getBusinessGroupById(businessID));
        setSelectedBusiness(businessData.business);
      } catch (error) {
        console.error('Error fetching business data:', error);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        dispatch(masterHandler.getPrefixNames('NATURAL')),
        dispatch(masterHandler.getProvinces()),
        dispatch(masterHandler.getEntityTypes()),
        dispatch(masterHandler.getRestaurantTypes()),
        dispatch(masterHandler.getShopProductCategories()),
        dispatch(masterHandler.getCurrencies()),
        dispatch(masterHandler.getVatCalculations())
      ]);

      await fetchBusinessData();
    };
    fetchData();
  }, [businessID]);

  const handleBusinessUpdate = async () => {
    await fetchBusinessData();
    setModalBusiness(prev => ({ ...prev, open: false }));
  };

  const handlePackageUpdate = async () => {
    await fetchBusinessData();
    setModalPackage(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="mt-2 mb-4">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="/customer" className="tc-7  text-decoration-none">
              ตั้งค่าธุรกิจ{' '}
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {' '}
            ข้อมูลธุรกิจ{' '}
          </li>
        </ol>
      </nav>

      <div className="text-2xl tc-7   mb-4 lh-1">{selectedBusiness?.company_name || ''}</div>
      <div className="grid grid-cols-12 gap-4">
        <div className="md:col-span-6 col-span-12">
          <Card className="!rounded-lg mb-4">
            <div className="bg-[#4C4E64]/[0.05] px-3 py-2 font-semibold text-lg text-[#4C4E64]/[0.87]">
              <LockOpenIcon className="!text-[#FDB528] mt-[-4px] mr-2" /> แพ็คเกจ
            </div>
            {selectedBusiness?.packageMain && (
              <div className="py-3 px-4">
                <div className="flex items-center justify-between font-semibold text-[#636578] mb-3">
                  <div>แพ็คเกจ</div>
                  <div>จำนวน</div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>
                    <div
                      className={`h-[28px] px-2 rounded text-center text-white ${
                        selectedBusiness.packageMain.is_package_default ? 'bg-[#2DC76D]' : 'bg-[#FDB528]'
                      }`}
                    >
                      {selectedBusiness.packageMain.name}
                    </div>
                  </div>
                  <div>{selectedBusiness.packageExpireDate}</div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนเมนู</div>
                  <div>
                    {selectedBusiness.qtyMenu} / {selectedBusiness.qtyLimitMenu}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนสาขา</div>
                  <div>
                    {selectedBusiness.qtyBranch} / {selectedBusiness.qtyLimitBranch}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนบิลขาย (รวมทุกสาขา) / เดือน</div>
                  <div>
                    {selectedBusiness.qtyBill} / {selectedBusiness.qtyLimitBill}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวน POS</div>
                  <div>
                    {selectedBusiness.qtyPos} / {selectedBusiness.qtyLimitPos}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนครัว</div>
                  <div>
                    {selectedBusiness.qtyKitchen} / {selectedBusiness.qtyLimitKitchen}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนผู้ใช้งานระบบ</div>
                  <div>
                    {selectedBusiness.qtyUser} / {selectedBusiness.qtyLimitUser}
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>จำนวนฐานข้อมูล</div>
                  <div>
                    {selectedBusiness.qtyDatabase} / {selectedBusiness.qtyLimitDatabase} MB
                  </div>
                </div>
                <div className="flex items-center justify-between  text-[#636578] mb-3">
                  <div>MEMBER ( จำนวนสมชิกในระบบ )</div>
                  <div>
                    {' '}
                    {selectedBusiness.qtyMember} / {selectedBusiness.qtyLimitMember}
                  </div>
                </div>
              </div>
            )}
          </Card>
          <div className="text-center">
            <Button
              variant="contained"
              className="!border-[#409FFB] !bg-[#409FFB] !rounded-lg text-[#FFF]"
              onClick={() => setModalPackage(prev => ({ ...prev, open: true }))}
            >
              เปลี่ยนเเพ็คเกจ
            </Button>
          </div>
        </div>
        <div className="md:col-span-6 col-span-12">
          <Card className="!rounded-lg mb-4">
            <div className="bg-[#4C4E64]/[0.05] px-3 py-2  font-semibold text-lg text-[#4C4E64]/[0.87]">
              <TextSnippetIcon className="!text-[#FDB528] mt-[-4px] mr-2" />
              ข้อมูลใบกำกับภาษี / ใบเสร็จรับเงิน
            </div>
            <div className="p-3">
              <div className="text-[#636578] mb-2">
                {selectedBusiness?.entity_type_id === 1
                  ? selectedBusiness?.company_name
                  : `${
                      prefixNames && selectedBusiness?.prefix_name_id
                        ? prefixNames?.find(e => e.id === selectedBusiness?.prefix_name_id)?.name || ''
                        : ''
                    } ${selectedBusiness?.first_name || ''} ${selectedBusiness?.last_name || ''}`}
              </div>
              <div className="text-[#636578] mb-2">{selectedBusiness?.address}</div>
              <div className="text-[#636578] mb-2">เบอร์โทร {selectedBusiness?.contact_phone_number}</div>
              <div className="text-[#636578] mb-3">Email : {selectedBusiness?.contact_email}</div>
              <div className="text-[#636578] mb-1">เลขประจำตัวผู้เสียภาษี</div>
              <div className="text-[#636578] mb-7">{selectedBusiness?.tax_number}</div>

              <Button
                variant="outlined"
                className="!border-[#409FFB] !rounded-lg text-[#409FFB]"
                onClick={() => setModalBusiness(prev => ({ ...prev, open: true }))}
              >
                แก้ไขข้อมูลธุรกิจ
              </Button>
            </div>
          </Card>
        </div>
      </div>
      <BusinessModal
        modal={modalBusiness}
        setModal={setModalBusiness}
        selectedBusiness={selectedBusiness}
        onSuccess={handleBusinessUpdate}
      />
      <ChangePackageModal modal={modalPackage} setModal={setModalPackage} onSuccess={handlePackageUpdate} />
    </>
  );
}
